
import { defineComponent, PropType, provide } from 'vue';
import { useVModel } from 'vue-composable';
import { useStore } from '@/store';
import { Vendor } from '@/types/app';
import { InjectionKeys } from '@/constants';
import AppModal from '@/components/modal/base/AppModal.vue';

export default defineComponent({
  name: 'VendorDeleteFormModal',
  emits: ['update:openState'],
  components: {
    AppModal
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    vendor: {
      type: Object as PropType<Vendor>
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');

    const store = useStore();
    const submit = async () => props.vendor && store.dispatch.vendors.delete(props.vendor);

    provide(InjectionKeys.FormSubmit, submit);

    return {
      isOpen
    };
  }
});
